import StateObserver from 'src/StateObserver';
import { getCurrentScene } from 'src/lib/stateUtils';
import * as Fate from 'src/replicant/fate';
import * as Tutorial from 'src/replicant/tutorial';
import { dreamDriftIsInstanceActive } from 'src/replicant/dreamDrift/dreamDrift.getters';
import { LockedStatus } from '../components/footer/footer.utils';

/**
 * Get the locked status of the care action.
 * @returns
 */
export function getCareActionLocked(): LockedStatus {
  const { user } = StateObserver.getState();
  const now = StateObserver.now();

  if (!Tutorial.getters.isTutorialStepComplete(user, 'chatWithPets')) {
    return { locked: true };
  }

  // Pet care remains unavailable while Dream Drift owns the pet presentation.
  if (dreamDriftIsInstanceActive(user, now)) {
    return { locked: true, reason: 'dreamDrift' };
  }

  if (Fate.getters.getVisiblePetState(user, now) === 'dead') {
    return { locked: true, reason: 'dead' };
  }

  if (getCurrentScene() === 'bedroom') {
    return { locked: true, reason: 'sleeping' };
  }

  if (Fate.getters.hasPermanentStatusEffect(user, 'daycare', now)) {
    return { locked: true, reason: 'daycare' };
  }

  return { locked: false, reason: undefined };
}
